import { Pipe, PipeTransform } from "@angular/core";
import { ReminderService } from "src/app/services/reminder.service";

@Pipe({
  name: "reminder",
  standalone: false,
})
export class ReminderPipe implements PipeTransform {
  constructor(private reminderService: ReminderService) {}

  transform(value: number, arg: string = ""): string {
    if (arg === "type") return this.reminderService.types.find((x) => x.key === value)?.title;
    if (arg === "interval")
      return this.reminderService.intervals.find((x) => x.key === value)?.title;
  }
}
